import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import store from '@/store/index'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import requestShopEdit from './request/requestShopEdit'
import requestShopRegister from './request/requestShopRegister'

const Actions = {
  // SHOP02 店舗登録
  registerShop: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestShopRegister.request.createRequest(params)
    return await axios
      // .get(apiMock.SHOP_REGISTER_EDIT)
      .post(api.SHOP_REGISTER_EDIT, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SHOP01 店舗一覧取得
  getShopListFromApi: async ({
    state,
    dispatch,
    commit,
    getters,
    rootGetters,
    rootState
  }) => {
    const ret = await axios
      // .get(apiMock.SHOP_LIST)
      .get(api.SHOP_LIST)
      .then((response) => {
        const path = mutationsTypes.SHOP_SET_SHOP_LIST
        commit(path, response.data)

        const getData = getters.getShopListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // uiControll.commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SHOP03 店舗編集
  editShop: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()

    let req = requestShopEdit.request.createRequest(params)
    return await axios
      // .get(apiMock.SHOP_REGISTER_EDIT)
      .patch(`${api.SHOP_REGISTER_EDIT}/${params.shopId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  }
}

export default Actions
